import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_pebitda-gym-tool/artifacts/rq4r92t1_GymSales%20logo.png";
const FOOTER_URL =
  "https://customer-assets.emergentagent.com/job_pebitda-gym-tool/artifacts/g28qwpq1_Gym.png";

export function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200/70 bg-white/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="GymSales.com.au" className="h-10 w-auto" />
        </Link>
        <nav className="flex items-center gap-2 text-sm sm:gap-3">
          <Link
            data-testid="header-recent-sales-btn"
            to="/recent-sales"
            className="inline-flex rounded-full px-2 py-2 font-semibold text-slate-600 hover:text-slate-900 sm:px-3"
          >
            Recent sales
          </Link>
          <Link
            data-testid="header-start-btn"
            to="/valuation"
            className="inline-flex rounded-full border border-slate-200 px-3 py-2 font-semibold text-slate-700 hover:bg-slate-50 sm:px-4"
          >
            Start valuation
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-10 text-center">
        <img
          src={FOOTER_URL}
          alt="GymSales in partnership with Bonza Business & Franchise Sales"
          className="h-14 w-auto"
          data-testid="footer-partnership-logo"
        />
        <p className="text-xs text-slate-500 max-w-xl">
          GymSales.com.au — indicative gym business valuations for Australian gym
          and fitness studio owners. In partnership with Bonza Business &amp;
          Franchise Sales.
        </p>
        <p className="text-sm font-semibold text-slate-700">
          Call Us Now on{" "}
          <a
            href="tel:1800316843"
            data-testid="footer-phone-link"
            className="text-orange-600 hover:text-orange-700"
          >
            1800 316 843
          </a>
        </p>
        <p className="text-xs text-slate-400">
          © {new Date().getFullYear()} GymSales.com.au. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#FAFAF9]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
